import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Porta } from '../../../models/porta';
import { AbPorta } from 'app/abstract/full-pages/config-portas/porta.abstract';

@Injectable({ providedIn: 'root' })
export class PortaService extends AbPorta {

  constructor(http: HttpClient) {
    super(http);
  }

  public getPortas(): Observable<any> {
    return this.get("porta/all");
  }

  public getPortasAtivas(): Observable<any> {
    return this.get("porta/all/ativas");
  }

  public getPortasAtivasReduzidas(): Observable<any> {
    return this.get("porta/all/ativas_reduzidas");
  }

  public getPortaById(id: number): Observable<any> {
    return this.get(`porta/${id}`)
  }

  public getPortaByIdDto(id: number): Observable<any> {
    return this.get(`porta/dto/${id}`)
  }

  public salvar(entity): Observable<any> {
    return this.save(`porta/`, entity);
  }

  public getPortasInativasPromise() {
    return this.get("porta/all/inativas").toPromise().catch();
  }

  public getPortasAtivasPromise() {
    return this.get("porta/all/ativas").toPromise().catch();
  }

  public salvarAlterarPortaPromise(porta: Porta) {
    return this.save('porta/', porta).toPromise().catch();
  }
}
